<script setup lang="ts">
import { useMessagesStore } from '../../../stores/messagesStore'
import BTooltipBtn from '@/components/base/BTooltipBtn/BTooltipBtn.vue'
import mdiClose from '~icons/mdi/close'

const messages = useMessagesStore()
</script>

<template>
  <v-snackbar-queue
    v-model="messages.queue"
    location="bottom center"
    :timeout="5000"
    :total-visible="5"
    collapsed
    closable
  >
    <template #actions="{ item, props: actionProps }">
      <b-tooltip-btn
        v-if="typeof item === 'string' || item.timeout !== -1"
        v-bind="actionProps"
        icon
        tooltip="close"
        tooltip-location="top"
      >
        <v-icon :icon="mdiClose" />
      </b-tooltip-btn>
    </template>
  </v-snackbar-queue>
</template>
